import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=c461cdd4&scoped=true"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c461cdd4",
  null
  
)

export default component.exports